import { useCallback } from 'react';
import { useStanRouter } from '@/hooks/useStanRouter';
import type { User } from '@/types/user';

/**
 * Routing priority (matching Vue's Register.vue userRegistered() method):
 * 1. add_socials_before_subscription experiment → /subscribe/socials
 * 2. redirectTo in sessionStorage → redirect there (fallback to /subscribe/plan)
 * 3. Default → /subscribe/plan
 */
export function usePostRegistrationRouting() {
    const { push } = useStanRouter();

    const navigateAfterRegistration = useCallback(
        (user?: User | null) => {
            // Check for add_socials_before_subscription experiment
            if (user?.experiments?.add_socials_before_subscription === 1) {
                push('/subscribe/socials');
                return;
            }

            // Check for redirectTo in sessionStorage
            const redirectTo = sessionStorage.getItem('redirectTo');
            if (redirectTo) {
                sessionStorage.removeItem('redirectTo');
                try {
                    push(redirectTo);
                } catch {
                    push('/subscribe/plan');
                }
                return;
            }

            // Default: subscription plan selection
            push('/subscribe/plan');
        },
        [push]
    );

    return { navigateAfterRegistration };
}
